import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { UnboardingResourcePackage } from "../../../resources/UnboardingResourcePackage";

export class PiggyBankContainer extends Container {

    public constructor(unboardingResources: UnboardingResourcePackage) {
        super();
        const piggyIcon = new Sprite(unboardingResources.assets_views_unboarding_piggy_png);
        this.addChild(piggyIcon);
        const toYourText = new Text(`TO YOUR`, new ContainerTextStyle());
        toYourText.style.fontSize = 52;
        toYourText.angle = -5;
        toYourText.skew.x = -0.08;
        toYourText.position.set(351, 263);
        this.addChild(toYourText);
        const piggyBankText = new Text(`PIGGY BANK!`, new ContainerTextStyle());
        piggyBankText.style.fill = ["#ff445a", "#ff2687", "#ff0ab1"];
        piggyBankText.angle = -5;
        piggyBankText.skew.x = -0.08;
        piggyBankText.position.set(354, 307);
        this.addChild(piggyBankText);
    }
}

class ContainerTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 78,
            fill: 'ffffff'
        });
    }
}